export default "__VITE_ASSET__Dp0NfaMk__"